import React from 'react';

import moment from 'moment';

// UI for a scheduled event
export default function scheduleEvent (ev) {
    var loc = ev.location;
    function locLine (content, i) {
        if (!loc[content]) return;
        return (<div key={i} className="location-line">{loc[content]}</div>);
    }

    return (
        <li key={ev.eventID} className="schedule-item container-fluid">
            <div className="row schedule-row schedule-head">
                <div key='title' className='col-sm-8 schedule-title'>
                    <h2>{ev.title}</h2>
                </div>

                <div key='startDate' className="col-sm-4 schedule-date">
                    {moment(ev.startDateTime).format('ddd, MMM D - YYYY')}
                </div>

                <div className="col-xs-12"><hr /></div>
            </div>

            <div className="row schedule-row">
                <div key='location' className="col-xs-6 schedule-location schedule-item-section">
                    <h3>Location</h3>

                    {loc ?
                        [
                            'locationName',
                            'locationContact',
                            'locationPhone',
                            'locationAddress'
                        ].map(locLine) :
                        'Unknown'
                    }

                </div>

                <div key='techs' className="col-xs-6 schedule-techs schedule-item-section">
                    <h3>Technicians</h3>
                    <ul className="schedule-techs">
                        {ev.technicians.map(function (t) {
                            return (<li key={t} className="schedule-tech">
                                {t}
                            </li>);
                        })}
                    </ul>
                </div>
            </div>

            <div className="schedule-row row">
                <div key='desc' className="col-xs-12 schedule-description schedule-item-section">
                    <h3>Description</h3>
                    {ev.description ? (
                        <p dangerouslySetInnerHTML={{__html: ev.description}}/>
                    ) : <em>No description given.</em>}
                </div>
            </div>

        </li>
    );
};
